import React,{useEffect} from "react";
import OpenAiImage from "./components/OpenAiImage";
import Hire from "./components/Hire";
import { BrowserRouter, Routes, Route ,Navigate} from "react-router-dom";
import Home from "./components/Home";
import mongoose from 'mongoose'
import ChatBox from './components/ChatBox'
// import ShoppingCardWidget from './components/ShoppingCartWidget'
import Gpt3 from './components/Gpt3'
import PrivateRoute from "./components/PrivateRoute";
import Blog from "./components/Blog";
import Sitemap from "./components/Sitemap";
import References from "./components/References"
import OpenAi from "./components/OpenAi";
import LyricalAi from "./components/LyricalAi";
import APIEndpointsAi from "./components/APIEndpointsAi";
import QuotesAi from './components/QuotesAi'
import StoryTeller from "./components/StoryTeller";
import WriteTheCommand from "./components/WriteTheCommand";
import ResumeBuilder from './components/ResumeBuilder'
import Chores from './components/Chores'
import Login from './components/auth/Login'
import Register from './components/auth/Register'
import HomeResponsive from './components/HomeResponsive'
import ResumeForm from "./components/ResumeForm";
import TermsOfService from "./components/TermsOfService";
import PrivacyPolicy from "./components/PrivacyPolicy";
import "./index.css"
import "./App.css"
import SupportEngine from "./components/Support/SupportEngine";
import Chart from './components/Chart'
import Chat from './components/Chat'
import {ToastContainer} from 'react-toastify'
import PhotoBook from './components/PhotoBook'
import OpenAiRoute from "./components/OpenAiRoute"
import { Provider } from 'react-redux';
import store from './store';
import { loadUser } from './actions/auth';
import setAuthToken from './utils/setAuthToken';
import Tetris from './components/Tetris'
import { LOGOUT } from './actions/types';
import CryptoForm from "./components/CryptoForm";
import SharedComponents from "./components/SharedComponents";

const App = () => {
    useEffect(() => {
        // check for token in LS when app first runs
        if (localStorage.token) {
          // if there is a token set axios headers for all requests
          setAuthToken(localStorage.token);
        }
        // try to fetch a user, if no token or invalid token we
        // will get a 401 response from our API
        store.dispatch(loadUser());
    
        // log user out from all tabs if they log out in one tab
        window.addEventListener('storage', () => {
          if (!localStorage.token) store.dispatch({ type: LOGOUT });
        });
      }, []);
    

   return( 

    <Provider store={store}>

<BrowserRouter>
<ToastContainer/>
<Routes>

<Route path='/chart' element={<Chart/>}/>


<Route path="/" element={<Home/>}/>
<Route path="/hire" element={<Hire/>}/>
<Route path="/sitemap" element={<Sitemap/>}/>
<Route path="/shoutouts" element={<References/>}/>
<Route path="/blog" element={<Blog/>}/>
<Route path="/openai/m1/completion/quotes" element={<QuotesAi/>}/>
<Route path="/openai/m1/completion/command" element={<WriteTheCommand/>}/>
<Route path="/tetris" element={<Tetris/>}/>
{/* <Route path='/shop' element={<ShoppingCardWidget/>}/> */}
<Route path="/openai/m1/completion/build-a-resume" element={<ResumeBuilder/>}/>
<Route path="/openai/m1/stream/gpt3" element={<Gpt3/>}/>

<Route path="/openai/m1/completion/resume.py" element={<ResumeForm/>}/>

<Route path="/openai/m1/completion/chat" element={<Chat/>}/>
<Route path="/support" element={<SupportEngine/>}/>
{/* <Route path="/chat" element={<ChatBox/>}/> */}
<Route path="/openai/m1/completion/endpoints" element={<APIEndpointsAi/>}/>
<Route path="/openai/m1/completion/lyrics" element={<LyricalAi/>}/>
<Route path="/termsofservice" element={<TermsOfService/>}/>
<Route path="/responsive" element={<HomeResponsive/>}/>
<Route path="/privacypolicy" element={<PrivacyPolicy/>}/>
<Route path="/openai/m1/completion/storytime" element={<StoryTeller/>}/>
<Route path="/openai/m1/completion/chores" element={<Chores/>}/>
<Route path="/login" element={<Login/>}/>
<Route path='/register' element={<Register/>}/>
<Route path='/picture-book' element={<PhotoBook/>}/>
<Route path="/openai/m1/images" element={<OpenAiImage/>}/>
<Route path="/openai/m1/select/" element={<OpenAi/>}/>
<Route path="/dex" element={<CryptoForm/>}/>
<Route path="/sharedcomponent" element={<SharedComponents/>}/>


<Route
            path="openai/m1/select/:email"
            element={<PrivateRoute component={OpenAi} />}
          />
</Routes>

</BrowserRouter>

</Provider>


)

}

export default App;
